var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Card } from '@philips-internal/oswald-ui-components/lib/components';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import SecurityAlertCardAPI from './security-alert-card-api';
import './security-alert-card.css';
let SecurityAlertCard = class SecurityAlertCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { securityAlerts, onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        securityAlerts
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    renderIndicatorColorStatus(item) {
        return (React.createElement(React.Fragment, null, item.colorLevelDescription && (React.createElement("div", { style: { backgroundColor: item.colorLevelDescription }, className: 'c-security-alert-card__indicator-color' }))));
    }
    renderField(item) {
        return (React.createElement("div", { className: 'c-security-alert-card__content' },
            React.createElement("h4", { className: 'c-security-alert-card__title' }, item.alertDescription),
            React.createElement("span", { className: 'c-security-alert-card__sub-title' }, item.alertComplementDescription)));
    }
    render() {
        const { securityAlerts } = this.props;
        return (React.createElement(React.Fragment, null, securityAlerts && securityAlerts.map((item, index) => (React.createElement(Card, { key: index, className: 'c-security-alert-card', onClick: () => this.handleClick(), selectionType: SelectionType.SINGLE, uuid: generateUUID(), width: 12 },
            this.renderIndicatorColorStatus(item),
            this.renderField(item))))));
    }
};
SecurityAlertCard = __decorate([
    AwesomeComponent({ api: SecurityAlertCardAPI, type: ComponentType.DATA_DISPLAY })
], SecurityAlertCard);
export default SecurityAlertCard;
//# sourceMappingURL=security-alert-card.js.map